export default "__VITE_ASSET__LHy0jTJU__"